import Search from "./components/search";
import ModalMenu from "./components/modal-menu";
import ModalVideo from "./components/modal-video";
import AudioPlayerDetail from "./components/audio-player-detail";
import WatchCarousel from "./components/watch-carousel";
import PageAnimate from "./components/page-animate";
import PageNav from "./components/pagenav";
import RecommendSlider from "./components/recommend-slider";
import AudioPlayerSlider from "./components/audio-player-slider";
import TimelineSlider from "./sliders/timeline-slider";
import Swiper, {EffectCards, FreeMode, Lazy, Navigation, Pagination} from "swiper";
import ArticleClose from "./components/article-close";
import {ModalMistake} from "./components/modal-mistake";
import {ScheduleList} from "./components/schedule-list";
import {TimelineTabsSlider} from "./components/timeline-tabs-slider";
import {useQuizPopupBtn} from './components/quiz';
import VideoHls from "./components/video-hls";
import './components/video-autoplay-check'
import EpisodeSlider from "./sliders/episode-slider";
import WatchSlider from "./sliders/watch-slider";
import Player from "./components/player";
import OverflowSlider from "./sliders/overflow-slider";
import CollapseText from "./components/collapse-text";
import {cookieManager} from "./utils/cookie-manager";
import Popup from "./components/popup";
import ItcCollapse from "./components/collapse-v2";
import PodcastAudioPlayer from "./sliders/podcast-audio-player";
import StickyInner from "./components/sticky-inner";
import PrintText from "./components/print-text";
import LookSlider from "./sliders/look-slider";
import Marque from "./sliders/marque";

Swiper.use([Navigation, Lazy, Pagination, EffectCards, FreeMode]);
const isHomePage = window.location.pathname == '/' || window.location.pathname == '/slider2.php';


function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
}

if (!isHomePage) {
    new StickyInner();
}

$(function () {

    //new FixHeader();
    new ModalMenu();
    new ModalVideo();
    //new AudioListPlayer();
    new PageAnimate();

    useQuizPopupBtn('.js-quiz-popup', {
        codeAttribute: 'data-quiz-code'
    });

    $('.mobile-recommend-slider .swiper-container').each((id, el) => {
        new RecommendSlider(el);
    });

    if (window.innerWidth < 1200) {
        Array.from(document.querySelectorAll(".footer-new--nav .footer-new--nav--list")).forEach(
            (item) => new ItcCollapse(item, 350, true, ".footer-new--nav__title")
        );
    }

    new Swiper('.mobile-section-slider', {
        slidesPerView: 'auto',
        spaceBetween: 18,
        freeMode: false
    });


    /*new Swiper('.b-program-tags', {
        slidesPerView: 'auto',
        freeMode: false,
        spaceBetween: 18,
    });*/

    const sections = new Swiper('.article-category-slider', {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: false,
        breakpoints: {
            992: {
                spaceBetween: 20,
            }
        }
    });
    const btnSlideSection = $('.js-slide-sections');
    if (btnSlideSection) {
        btnSlideSection.on('click', (btn) => {
            (sections as any).forEach((e) => {
                if ($(btn.currentTarget).hasClass('btn-next'))
                    e.slideNext();
                else
                    e.slidePrev();
            })
        })
    }

    const sectionSlideId = $('.article-category-slider .program-tags-slider-item.active').data('slickId');
    if (sectionSlideId && sections) {
        sections[0].slideTo(sectionSlideId);
        sections[1].slideTo(sectionSlideId);
    }

    let programSliders = {};

    let getSliderParams = function (container) {
        return {
            spaceBetween: 18,
            slidesPerView: 'auto',
            freeMode: false,
            updateOnWindowResize: true,
            breakpoints: {
                768: {
                    slidesPerView: 3
                }
            },
            navigation: {
                nextEl: container.find('.btn-next').get(0),
                prevEl: container.find('.btn-prev').get(0),
                hiddenClass: 'd-none',
                disabledClass: 'd-none',
            }
        }
    }

    document.querySelectorAll(".program-slider-wrapper .tab-pane").forEach((el) => {
        let tabId = '#' + el.getAttribute('id');
        programSliders[tabId] = new Swiper(`${tabId} .swiper-container`, (getSliderParams($(el)) as any));
    });
    $(".b-program-tags a").not('.btn-tag-link')
        .on('click', (e) => {
            e.preventDefault();
            $(".b-program-tags a.active").removeClass("active");
            ($(e.target) as any).tab("show");
        })
        .on('shown.bs.tab', (e) => {
            const selector = $(e.target).data("target");
            if (typeof programSliders[selector] !== 'undefined') {
                programSliders[selector].destroy()
                programSliders[selector] = new Swiper(`${selector} .swiper-container`, (getSliderParams($(e.target)) as any));
            }
        });


    new Swiper('.program-main-slider-wrapper', {
        lazy: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 18,
        loop: true,
        breakpoints: {
            768: {
                spaceBetween: 21
            }
        },
        navigation: {
            nextEl: ".b-program-main-slider-section .btn-next",
            prevEl: ".b-program-main-slider-section .btn-prev"
        }
    });

    let sliderWrapper = $(".program-slider-wrapper.swiper-container").parent();

    new Swiper(".program-slider-wrapper.swiper-container", {
        spaceBetween: 18,
        slidesPerView: 'auto',
        freeMode: false,
        updateOnWindowResize: true,
        breakpoints: {
            768: {
                spaceBetween: 30,
            },
            992: {
                spaceBetween: 18,
                slidesPerView: 3
            }
        },
        navigation: {
            nextEl: sliderWrapper.find('.btn-next').get(0),
            prevEl: sliderWrapper.find('.btn-prev').get(0),
            hiddenClass: 'd-none',
            disabledClass: 'd-none',
        }
    });

    new Swiper('.festival-slider-wrapper', {
        lazy: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 18,
        loop: true,
        /* autoplay: {
             delay: 7000,
             disableOnInteraction: false,
         },*/
        pagination: {
            el: ".swiper-pagination",
        },
        freeMode: false,
        updateOnWindowResize: true,
    });

    new Swiper('.podcasts__slider', {
        lazy: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 18,
        loop: true,
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        freeMode: false,
        updateOnWindowResize: true,
    });
    new EpisodeSlider()


    new Swiper('.podcasts__slider-inner-wrapper', {
        // lazy: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 16,
        freeMode: false,
        updateOnWindowResize: true,
    });


    new Swiper('.quiz-slider-wrapper', {
        lazy: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 16,

        updateOnWindowResize: true,
    });

    new Swiper('.quiz-main-slider__container', {
        loop: false,
        spaceBetween: 32,
        slidesPerView: 'auto',
        freeMode: false,
        updateOnWindowResize: true,
    });

    new Swiper('.header-news__first', {
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        loop: true,
        slidesPerView: 'auto',
        spaceBetween: 32,
        updateOnWindowResize: true,
    });

    new Swiper('.watch-section_many .watch-section__list', {
        loop: false,
        grabCursor: true,
        spaceBetween: 8,
        slidesPerView: 'auto',
        breakpoints: {
            992: {
                spaceBetween: 20
            }
        },
        updateOnWindowResize: true,
        navigation: {
            nextEl: '.watch-section__slider-controls .btn-next',
            prevEl: '.watch-section__slider-controls .btn-prev',
            hiddenClass: 'd-none',
            disabledClass: 'd-none'
        },
    });

    new Swiper('.watch-section_three .watch-section__list', {
        loop: false,
        grabCursor: true,
        spaceBetween: 16,
        slidesPerView: 'auto',
        breakpoints: {
            992: {
                spaceBetween: 20
            }
        },
        updateOnWindowResize: true,
        navigation: {
            nextEl: '.watch-section__slider-controls .btn-next',
            prevEl: '.watch-section__slider-controls .btn-prev',
            hiddenClass: 'd-none',
            disabledClass: 'd-none'
        },
    });


    new Swiper('.watch-section_two .watch-section__list', {
        loop: false,
        grabCursor: true,
        spaceBetween: 16,
        slidesPerView: 'auto',
        breakpoints: {
            992: {
                spaceBetween: 20
            },
            // 576: {
            //     allowTouchMove: false,
            // }
        },
        updateOnWindowResize: true,
        navigation: {
            nextEl: '.watch-section__slider-controls .btn-next',
            prevEl: '.watch-section__slider-controls .btn-prev',
            hiddenClass: 'd-none',
            disabledClass: 'd-none'
        },
    });

   /* new Swiper('.news-second__slider .swiper', {
        autoplay: {
            delay: 7000,
            disableOnInteraction: false,
        },
        effect: 'cards',
        cardsEffect: {
            rotate: false,
            slideShadows: false,
            perSlideOffset: 8,
        },
        pagination: {
            el: ".news-second__pagination",
        },
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 32,
        updateOnWindowResize: true,
    });
*/
    new Swiper(".actors-slider.swiper-container", {
        spaceBetween: 18,
        slidesPerView: 'auto',
        freeMode: false,
        updateOnWindowResize: true,
        breakpoints: {
            768: {
                spaceBetween: 30,
                slidesPerView: 3
            },
            992: {
                spaceBetween: 18,
            },
            1200: {
                spaceBetween: 18,
                slidesPerView: 5
            }
        },
        navigation: {
            nextEl: $(".actors-slider.swiper-container").parent().find('.btn-next').get(0),
            //hiddenClass: 'd-none',
            //disabledClass: 'd-none',
        }
    });

    new Swiper('.movie__actors .swiper-container', {
        lazy: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 8,
        loop: true,
        breakpoints: {
            768: {
                // spaceBetween: 21,

                slidesPerView: 3,
            }
        },
        navigation: {
            nextEl: ".movie__actors .btn-next"
        }
    });

    new Swiper('.games-preview-slider', {
        lazy: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 8,
        loop: false,
        breakpoints: {
            768: {
                spaceBetween: 21,

                slidesPerView: 5,
            }
        },
        on: {
            init(swiper) {
                this.freeModeSlider = new OverflowSlider(swiper, {
                    enableBreakpointDown: 567,
                    container: 21,
                    spaceBetween: 8,
                    freeMode: true,
                    stepByStep: false,
                    stopOnStep: false,
                    magnet: false,
                });
            }
        }
    });

    new Swiper('.movie__stuff .swiper-container', {
        lazy: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 18,
        loop: true,
        breakpoints: {
            768: {
                // spaceBetween: 21,
                spaceBetween: 30,
                slidesPerView: 5,
            }
        },
        navigation: {
            nextEl: ".movie__stuff .btn-next"
        }
    });

    new Swiper('#pictures .swiper-container', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 18,
        loop: false,
        breakpoints: {
            768: {
                // spaceBetween: 21,
                spaceBetween: 30,
            }
        }
    });

    new Swiper('#person-works .swiper-container', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 25,
        loop: false,
        breakpoints: {
            768: {
                // spaceBetween: 21,
                spaceBetween: 50,
            }
        }
    });

    new Swiper('.movie__similar-slider .swiper-container', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 8,
        loop: false,
        freeMode: {
            enabled: true,
            sticky: true
        },
        breakpoints: {
            768: {
                // spaceBetween: 21,s
                spaceBetween: 11,
            },
            992: {
                centeredSlides: true
            }
        }
    });

    new Swiper('.search-info-popup--slider .swiper-container', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 11,
        loop: false,
        freeMode: {
            enabled: true,
            sticky: true
        },
    });

    new Swiper('.person__works .swiper-container', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 14,
        loop: false,
        freeMode: {
            enabled: true,
            sticky: true
        },
        breakpoints: {
            567: {
                spaceBetween: 11,
                navigation: {
                    nextEl: ".person__works .btn-next",
                    prevEl: ".person__works .btn-prev",
                    hiddenClass: 'd-none',
                    disabledClass: 'd-none',
                },
            }
        }
    });

    new Swiper('.person__photo .swiper-container', {
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 8,
        loop: false,
        freeMode: {
            enabled: true,
            sticky: true
        },
        breakpoints: {
            567: {
                spaceBetween: 12,
                navigation: {
                    nextEl: ".person__photo .btn-next",
                    prevEl: ".person__photo .btn-prev",
                    hiddenClass: 'd-none',
                    disabledClass: 'd-none',
                },
            }
        }
    });

    new Swiper('.movies-collections--sections__item_even .movies-collections--sections__inner', {
        loop: false,
        grabCursor: true,
        spaceBetween: 16,
        slidesPerView: 'auto',
        breakpoints: {
            992: {
                spaceBetween: 28
            }
        },
        updateOnWindowResize: true,
        navigation: {
            nextEl: '.movies-collections--slider-controls .btn-next',
            prevEl: '.movies-collections--slider-controls .btn-prev',
            hiddenClass: 'd-none',
            disabledClass: 'd-none'
        },
    });

    new Swiper('.movies-collections--sections__item_odd .movies-collections--sections__inner', {
        loop: false,
        grabCursor: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        breakpoints: {
            992: {
                spaceBetween: 20
            }
        },
        updateOnWindowResize: true,
        navigation: {
            nextEl: '.movies-collections--slider-controls .btn-next',
            prevEl: '.movies-collections--slider-controls .btn-prev',
            hiddenClass: 'd-none',
            disabledClass: 'd-none'
        },
    });

    new Marque(".movies-collections--sections__item_first .movies-collections--sections__inner", 1);

    //new Gallery();

    window.addEventListener("load", function(){
        new PodcastAudioPlayer();
    });

    setTimeout(function () {

        Search.getInstance();
        new PageNav();
        new ModalMistake();
        new WatchSlider();
        new CollapseText();
        new PrintText();

        /* Sliders */
        new TimelineSlider();
        new TimelineTabsSlider();

        let preloader = $('#page-preloader');
        if (!preloader.hasClass('done'))
            preloader.addClass('done');

        /* Плеер на детальной */
        $('.listen-details-player').each((id, el) => {
            new AudioPlayerDetail(
                $(el), $(el).find('.listen-details-player-duration'),
                {
                    created: (player) => player.loadFile(),
                }
            )
        });

        $('.listen-details-issues').each((id, el) => {
            new AudioPlayerSlider($(el))
        })

        new LookSlider();

        if (isHomePage) {
            /* Слайдер на главной */
            //new HeaderSlider();
            //new GamesPopup();

            /* Анонсы на главной */
            //new Announcement();
        } else {
            new WatchCarousel();

            new ScheduleList();
            new ArticleClose();
        }
        new Player();

        /* Видео на главной */
        Array.from(document.querySelectorAll('.js-video-hls-wrapper'))
            .forEach((element: HTMLElement) => {
                new VideoHls(element);
            });

        if (isTouchDevice()) {
            $('html').addClass('bx-touch');
        }


        const popupTelegram = new Popup('#telegram-popup')
        if (cookieManager.get('telegram_popup') !== 'Y' && popupTelegram.element) {
            setTimeout(() => {
                popupTelegram.open()
                cookieManager.set('telegram_popup', 'Y', 365)
            }, 7000)
        }
    }, 100);


    const buttonsList = Array.from(document.querySelectorAll('._blue-radial'));

    buttonsList.forEach((e:HTMLElement) => {

        const a = e.offsetWidth;
        const h = e.offsetHeight / 2;
        e.style.setProperty("--size-square", a + "px")
        e.style.setProperty("--coord-x", 1 + "px")
        e.style.setProperty("--coord-y", h + "px")
        e.style.setProperty("--diameter-highlight", a * 1.2 + "px")

        cycle(
            (timeFraction) => {
                e.style.setProperty("--coord-x", a - (a * timeFraction) + "px")
            }, (timeFraction) => {
                e.style.setProperty("--coord-x", a * timeFraction + "px")
            },
            2500
        )
    })

    if (document.querySelector<HTMLElement>('.article-share_copy-link')) {
        document.querySelector<HTMLElement>(".article-share_copy-link").onclick = () => {
            let link = document.querySelector(".url-page-for-copy") as HTMLInputElement;
            link.select();
            document.execCommand("copy");
        }
    }

/*    const navbar = document.querySelector('.b-navbar .navbar') as HTMLElement
    if (navbar) {
        const nOffset = navbar.offsetWidth;

        cycle(
            (timeFraction) => {
                navbar.style.setProperty("--coord-x", nOffset - (nOffset * timeFraction) + "px")
            }, (timeFraction) => {
                navbar.style.setProperty("--coord-x", nOffset * timeFraction + "px")
            },
            2500
        )
    }*/

 /*   const footer = document.querySelector('footer')
    if (footer) {
        const fOffset = footer.offsetWidth * 1.5;

        cycle(
            (timeFraction) => {
                footer.style.setProperty("--coord-x", fOffset - (fOffset * timeFraction) + "px")
            }, (timeFraction) => {
                footer.style.setProperty("--coord-x", fOffset * timeFraction + "px")
            },
            2500
        )
    }*/


});



/* TODO !!*/
function cycle(callback, callback2, duration) {

    let prev = performance.now();

    let back = (time) => {
        let timeFraction = (time - prev) / duration;
        if (timeFraction > 1) timeFraction = 1
        callback(timeFraction)

        if (timeFraction < 1)
            requestAnimationFrame(back)
        else {
            prev = performance.now();
            requestAnimationFrame(forward)
        }
    }

    let forward = (time) => {
        let timeFraction = (time - prev) / duration;
        if (timeFraction > 1) timeFraction = 1
        callback2(timeFraction)

        if (timeFraction < 1)
            requestAnimationFrame(forward)
        else {
            prev = performance.now();
            requestAnimationFrame(back)
        }
    }

    requestAnimationFrame(forward)
}

